import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { LibraryService, Dropobj } from '../../services/library.service';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-aprvindent',
  templateUrl: './aprvindent.component.html',
  styleUrls: ['./aprvindent.component.scss'],
  providers:[LibraryService],
})
export class AprvindentComponent implements OnInit {

  bookdetails:any[];
  booksmodel:any={};
  @ViewChild('dt') table: any;

  statuses = [
    {value: 'Approved', label: 'Approved'},
    {value: 'Hold', label: 'Hold'},
    {value: 'Pending', label: 'Pending'},
    {value: 'Cancel', label: 'Cancel'},
   
  
  ];
  oprtype:string;
    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    private smallmodalRef: NgbModalRef;
    constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal,private _global: AppGlobals) {
  
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'lg'
      }
     }

  ngOnInit(): void {

    this.getbookdetails();
  }
  openbookdialog(content,formdata,cmd) {
    debugger
    console.log("formdata",formdata);
    this.modalOptions={size:'sm'};
    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.booksmodel={};
   
     
      this.booksmodel.inid='0';
     
      
      //this.booksmodel.rstatus='Active';
    
      this.booksmodel.publisher='';
  
      
      
      this.booksmodel.author='';
      this.booksmodel.indt=new Date();

      this.booksmodel.rmks='';
      this.booksmodel.note='';
      this.booksmodel.qty='1';
      this.booksmodel.edition='';
     
      this.booksmodel.title='';
      this.booksmodel.subtitle='';
     
  
  
      this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
    }
    else if (cmd=='update')
    {
      
      this.booksmodel=formdata;
      this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
  
    }
    
    
      
    
  
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  
  getbookdetails() {
    this.liservice.getallibtindent('all')
        .subscribe(
        resultArray => {
            console.log('books-result', resultArray);
            this.bookdetails = resultArray;
           // this.authorfilter();
          //   this.author  = resultArray [
          //     {'author'}
          // ];
        },
        error => console.log("Error :: " + error)
        )
}


  savebookdetails()
  {


    console.log('savedetails',this.booksmodel);
    this.liservice.authlibtindent(this.booksmodel)
.subscribe(result => {
   alert(result.message);
   
if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.getbookdetails();

}


else{


}
   

  
    
}, error => alert('error in connection')
);
  }

}
